
























import { Enterprise } from '@/resources/enterprise/Enterprise';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ENTERPRISE } from '@/router/work';
@Component
export default class EnterpriseCard extends Vue {
  @Prop() private enterprise!: Enterprise;
  public ENTERPRISE = ENTERPRISE;
}
